exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BackButton-module__wrapper___3XE4o{position:fixed;top:2rem;left:2rem;z-index:10;background-color:#181818;padding:.75rem;border-radius:15px;display:grid;justify-content:center;gap:1em}.BackButton-module__wrapper___3XE4o button{background:#fff;border-radius:100%;width:40px;height:40px;line-height:1}.BackButton-module__wrapper___3XE4o svg{color:#181818;font-size:20px;transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"wrapper": "BackButton-module__wrapper___3XE4o"
};